import { render, staticRenderFns } from "./pivotTable.vue?vue&type=template&id=c71adc58&scoped=true&"
import script from "./pivotTable.vue?vue&type=script&lang=js&"
export * from "./pivotTable.vue?vue&type=script&lang=js&"
import style0 from "./pivotTable.vue?vue&type=style&index=0&id=c71adc58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71adc58",
  null
  
)

export default component.exports